import { useCallback } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import {
  StyledDatePicker,
  StyledWrapper,
  StyledPicker,
  StyledRangeDivider,
} from './index.styles';

dayjs.extend(weekday);
dayjs.extend(localeData);

type CustomDateRange = {
  from: number | undefined;
  to: number | undefined;
};
interface IDateFilterProps {
  className?: string;
  onChange?: (dateRange: CustomDateRange) => void;
  value?: CustomDateRange;
  showTime?: {
    format: string;
  };
  format?: string;
  disabled?: boolean;
  enableDisabledFrom?: boolean;
  enableDisabledTo?: boolean;
}
function DateRangeFilter({
  className,
  onChange,
  value,
  showTime,
  format,
  disabled,
  enableDisabledFrom = true,
  enableDisabledTo = true,
}: IDateFilterProps) {
  let hasValue = Boolean(value?.from) || Boolean(value?.to);

  const disabledToDate = useCallback(
    (currentDate: Dayjs) => {
      const isBeforeFromDate = value?.from
        ? currentDate && currentDate.isBefore(dayjs.unix(Number(value.from)))
        : false;

      if (!enableDisabledTo) return isBeforeFromDate;

      const isAfterToday =
        currentDate && currentDate.isAfter(dayjs().endOf('day'));

      return isAfterToday || isBeforeFromDate;
    },
    [enableDisabledTo, value],
  );

  const disabledFromDate = useCallback(
    (currentDate: Dayjs) => {
      const isAfterToDate = value?.to
        ? currentDate && currentDate.isAfter(dayjs.unix(Number(value.to)))
        : false;

      if (!enableDisabledFrom) return isAfterToDate;

      const isAfterToday =
        currentDate && currentDate.isAfter(dayjs().endOf('day'));

      return isAfterToday || isAfterToDate;
    },
    [enableDisabledFrom, value],
  );

  return (
    <StyledWrapper hasValue={hasValue} className={className}>
      <StyledPicker
        placeholder="From date"
        hasValue={hasValue}
        format={format}
        showTime={showTime}
        disabled={disabled}
        onChange={(newValue) =>
          onChange &&
          onChange({
            from: (newValue as Dayjs)?.startOf('day').unix(),
            to: value?.to,
          })
        }
        disabledDate={disabledFromDate}
        value={Boolean(value?.from) ? dayjs.unix(Number(value?.from)) : null}
      />
      <StyledRangeDivider hasValue={hasValue} />
      <StyledPicker
        placeholder="To date"
        hasValue={hasValue}
        format={format}
        showTime={showTime}
        disabled={disabled}
        disabledDate={disabledToDate}
        onChange={(newValue) =>
          onChange &&
          onChange({
            from: value?.from,
            to: (newValue as Dayjs)?.endOf('day').unix(),
          })
        }
        value={Boolean(value?.to) ? dayjs.unix(Number(value?.to)) : null}
      />
    </StyledWrapper>
  );

  // return (
  //   <StyledRangePicker
  //     className={className}
  //     onChange={(dateRange) => {
  //       onChange &&
  //         onChange({
  //           from: dateRange?.[0]?.startOf('day').unix(),
  //           to: dateRange?.[1]?.endOf('day').unix(),
  //         });
  //     }}
  //     value={[
  //       Boolean(value?.from) ? dayjs.unix(Number(value?.from)) : null,
  //       Boolean(value?.to) ? dayjs.unix(Number(value?.to)) : null,
  //     ]}
  //     disabledDate={(currentDate) =>
  //       currentDate && currentDate.isAfter(dayjs().endOf('day'))
  //     }
  //     showTime={showTime}
  //     format={format}
  //     hasValue={Boolean(value?.from) || Boolean(value?.to)}
  //   />
  // );
}

export let DateFilter = {
  RangePicker: DateRangeFilter,
  DatePicker: StyledDatePicker,
};
